import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerAuthService } from 'src/app/public/customer-auth.service';
import { LocationService } from 'src/app/public/location.service';

@Component({
  selector: 'app-customer-login-button',
  templateUrl: './customer-login-button.component.html',
  styleUrl: './customer-login-button.component.scss',
})
export class CustomerLoginButtonComponent {

  @Input() next: string = '';

  constructor(
    private router: Router,
    private locationService: LocationService,
    private auth: CustomerAuthService,
  ) {}

  onLoginClick(event: Event) {
    event.preventDefault();
    // TODO: Handle next navigation
    this.router.navigateByUrl(this.locationService.base_url('login'));
  }

  displayLoginButton(): boolean {
    return (
      this.auth.enableCustomerAuth() &&
      !this.auth.isUserLoggedIn() &&
      this.locationService.getCurrentView() !== 'login'
    );
  }
}
